<template>
  <div class="main">
    <qy-header v-if="subTitle==''"></qy-header>
    <nav-bar v-if="subTitle==''"></nav-bar>
    <sub-nav v-if="subTitle!=''&&subTitle!=undefined" :title="subTitle"></sub-nav>
    <router-view />
    <foot-nav :tabs='tabs' :activeDefault="selectedLabelDefault" @childLabel="changeHandler"></foot-nav>
  </div>
</template>

<script>
import QyHeader from '@/views/QyHeader.vue'; // 主导航
import NavBar from '@/views/NavBar.vue'; // 主导航
import SubNav from '@/views/SubNav.vue'; // 子页面
import FootNav from '@/views/FootNav.vue';
export default {
  name: 'Main',
  components: {
    'qy-header': QyHeader,
    NavBar,
    SubNav,
    FootNav,
  },
  data() {
    return {
      subTitle: '',// this.$route.meta.subTitle,//// 
      selectedLabelDefault: '首页',
      tabs: [{
        label: '首页',
        icon: 'cubeic-home'
      },
      {
        label: '我的',
        icon: 'cubeic-person'
      }],
      metaTitle: ''
    }
  },
  computed: {

  },
  watch: {
    // '$router.meta': {
    //   subTitle (newValue, oldValue) {
    //     this.subTitle = newValue;
    //   },
    //   immediate: true,
    //   deep: true
    // },
    '$route.meta.subTitle'(newValue, oldValue) {
      this.subTitle = newValue;
    }
  },
  created() {
    this.subTitle = this.$route.meta.subTitle;
   
  },
  // beforeRouteEnter(to, from, next) {
    // next(vm => {
    //   vm.$set(vm.$data, 'subTitle' ,to.meta.subTitle)
    // });
  // },
  methods: {
    changeHandler(label) {
      // console.log(label)
      console.log('subTitle', this.subTitle)
      if (label == '我的') {
        this.$router.push({ path: 'Center' });
      } else {
        this.$router.push({ path: 'Index' });
      }
    },
  },
}
</script>

<style lang="scss" >
@import "../assets/css/base.scss";
</style>


// WEBPACK FOOTER //
// src/views/Main.vue